export enum RaceState {
    IDLE = 'idle',
    INITIATING_START = 'initiating_start',
    RACING = 'racing',
    ABORTED = 'aborted',
}
